<template>
  <div class="_lid-base-grid lid-base grid grid-cols-12 antialiased bg-app-lid--yellow-casablanca font-lid text-app-lid--blue-prussian bg-paw-thin">
    <!-- Control panel component to render admin tools when ?cp=true is added in the url -->
    <ClientOnly>
      <OrganismControlPanel />
    </ClientOnly>
    <OrganismLidMenu class="relative z-50 col-span-full row-start-1 w-full flex" />
    <slot />
    <client-only>
      <OrganismLidFooter class="col-span-full row-start-3" />
      <MoleculeLoaderOverlay />
    </client-only>
  </div>
</template>

<script setup lang="ts">
import { watch, onBeforeUnmount } from 'vue'
import { useOverlayStore } from '~/store/overlay'
import { useCookiebot } from '~/composables/cookiebot'

const overlayStore = useOverlayStore()
useCookiebot()

// Add `overflow-hidden` to the body whenever one of the overlays is open
watch(
  () => [overlayStore.loader, overlayStore.mobileMenu],
  ([loader, mobileMenu]) => {
    if (loader || mobileMenu) {
      document.body.classList.add('overflow-hidden')
    } else {
      document.body.classList.remove('overflow-hidden')
    }
  },
)

// Reset the overlay every time we load a new page
onBeforeUnmount(() => {
  overlayStore.reset()
})

useHead({
  meta: [
    { name: 'apple-mobile-web-app-title', content: 'Landelijke Inspectiedienst Dierenwelzijn' },
    { name: 'application-name', content: 'Landelijke Inspectiedienst Dierenwelzijn' },
    { name: 'msapplication-TileColor', content: '#f2b844' },
    { name: 'theme-color', content: '#ffffff' },
  ],
  link: [
    { rel: 'shortcut icon', type: 'image/x-icon', href: '/favicons/LID/favicon-lid.ico' },
    { rel: 'apple-touch-icon', sizes: '180x180', href: '/favicons/LID/apple-touch-icon.png' },
    { rel: 'mask-icon', color: '#f2b844', href: '/favicons/LID/safari-pinned-tab.svg' },
    { rel: 'icon', sizes: '32x32', href: '/favicons/LID/favicon-32x32.png' },
    { rel: 'icon', sizes: '16x16', href: '/favicons/LID/favicon-16x16.png' },
    { rel: 'manifest', href: '/favicons/LID/site.webmanifest' },
  ],
})
</script>

<style scoped lang="scss">
._lid-base-grid {
  min-height: 100vh;
  grid-template-rows: auto 1fr auto;
}
</style>
